import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import QuartzJobModal from "./modules/QuartzJobModal";
import { getAction } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import JEllipsis from '@/components/jeecg/JEllipsis';
export default {
  name: 'QuartzJobList',
  mixins: [JeecgListMixin],
  components: {
    QuartzJobModal: QuartzJobModal,
    JEllipsis: JEllipsis
  },
  data: function data() {
    return {
      description: '定时任务在线管理',
      // 查询条件
      queryParam: {},
      // 表头
      columns: [{
        title: '#',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '任务类名',
        align: 'center',
        dataIndex: 'jobClassName',
        sorter: true
        /*            customRender:function (text) {
            return "*"+text.substring(9,text.length);
          }*/

      }, {
        title: 'cron表达式',
        align: 'center',
        dataIndex: 'cronExpression'
      }, {
        title: '参数',
        align: 'center',
        dataIndex: 'parameter'
      }, {
        title: '描述',
        align: 'center',
        width: 300,
        dataIndex: 'description',
        scopedSlots: {
          customRender: 'description'
        }
      }, {
        title: '状态',
        align: 'center',
        dataIndex: 'status',
        scopedSlots: {
          customRender: 'customRenderStatus'
        },
        filterMultiple: false,
        filters: [{
          text: '已启动',
          value: '0'
        }, {
          text: '已暂停',
          value: '-1'
        }]
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 180,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        list: '/sys/quartzJob/list',
        delete: '/sys/quartzJob/delete',
        deleteBatch: '/sys/quartzJob/deleteBatch',
        pause: '/sys/quartzJob/pause',
        resume: '/sys/quartzJob/resume',
        run: '/sys/quartzJob/runjob',
        exportXlsUrl: 'sys/quartzJob/exportXls',
        importExcelUrl: 'sys/quartzJob/importExcel'
      }
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    //筛选需要重写handleTableChange
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.loadData();
    },
    pauseJob: function pauseJob(record) {
      var that = this; //暂停定时任务

      this.$confirm({
        title: '确认暂停',
        content: '是否暂停选中任务?',
        onOk: function onOk() {
          getAction(that.url.pause, {
            jobClassName: record.jobClassName
          }).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.loadData();
              that.onClearSelected();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          });
        }
      });
    },
    resumeJob: function resumeJob(record) {
      var that = this; //恢复定时任务

      this.$confirm({
        title: '确认启动',
        content: '是否启动选中任务?',
        onOk: function onOk() {
          getAction(that.url.resume, {
            jobClassName: record.jobClassName
          }).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.loadData();
              that.onClearSelected();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          });
        }
      });
    },
    runJob: function runJob(record) {
      var that = this; //运行定时任务

      this.$confirm({
        title: '确认运行',
        content: '是否运行选中任务?',
        onOk: function onOk() {
          getAction(that.url.run, {
            jobClassName: record.jobClassName
          }).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.loadData();
              that.onClearSelected();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          });
        }
      });
    }
  }
};